import React from 'react';
import styled, { keyframes } from 'styled-components';
import PowerButton from '../subComponents/PowerButton';
import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import { NavLink } from 'react-router-dom';
import { YinYang } from './AllSvgs';
import { useState, useEffect } from 'react'; 
import Intro from "./Intro"
import { motion } from 'framer-motion';


const MainContainer = styled.div`
  background: ${props => props.theme.body};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  
  h2, h3, h4, h5, h6 {
    font-family: 'Karla', sans-serif;
    font-weight: 500;
  }
;`

const Container = styled.div`
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
  }
;`

const Contact = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 1;

  @media (max-width: 768px) {
    top: 2rem;
    right: 2rem;
  }

  @media (max-width: 480px) {
    top: 1rem;
    right: 1rem;
    
    h2 {
      font-size: calc(0.8em + 1vw);
    }
  }
;`
const FEATS = styled(NavLink)`
  color: ${props => props.theme.text};
  position: absolute;
  top: 50%;
  right: 2rem;  /* Adjusted */
  transform:rotate(90deg) translateY(-50%);
  text-decoration: none;
  z-index: 1;

  @media (max-width: 768px) {
    right: 1rem;
  }

  @media (max-width: 480px) {
    right: 0.5rem;
    
    h2 {
      font-size: calc(0.8em + 1vw);
    }
  }
;`
const PROJECTS = styled(NavLink)`
  color: ${props => props.click ? props.theme.body : props.theme.text};
  position: absolute;
  top: 40%;  /* Further moved up */
  left: 0.5rem; /* Keeping the same left alignment */
  transform: translateY(-50%) rotate(-90deg);
  text-decoration: none;
  z-index: 1; 
  
  @media (max-width: 768px) {
    left: 0.3rem;
  }

  @media (max-width: 480px) {
    left: 0.2rem;
    
    h2 {
      font-size: calc(0.8em + 1vw);
    }
  }
`;
const BottomBar = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 0;
  right: 0;
  width: 100%; /* Add semicolon here */

  display: flex;
  justify-content: space-evenly;

  @media (max-width: 480px) {
    bottom: 0.5rem;
  }
;`

const ABOUT = styled(NavLink)`
  color: ${props =>props.click? props.theme.body:props.theme.text};
  text-decoration: none;
  z-index: 1;

  @media (max-width: 480px) {
    h2 {
      font-size: calc(0.8em + 1vw);
    }
  }
;`

const SKILLS = styled(NavLink)`
  color: ${props => props.theme.text};
  text-decoration: none;
  z-index: 1;

  @media (max-width: 480px) {
    h2 {
      font-size: calc(0.8em + 1vw);
    }
  }
;`

const rotate=keyframes`
from{
  transform:rotate(0);
}
to{
  transform:rotate(360deg);
}`

const Center=styled.button`
position:absolute;
top:${props=>props.click? '85%':'50%'};
left:${props=>props.click? '92%':'50%'};
transform:translate(-50%,-50%);
border:none;
outline:none;
cursor:pointer;
background-color: transparent;
color:${props=>props.click? props.theme.text:props.theme.text};

display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
transition:all 1s ease;

&>:first-child{
  animation:${rotate} infinite 1.5s linear;
}

&>:last-child{
  display:${props=>props.click? 'none':'inline-block'};
  padding-top:1rem;
  color:${props=>props.click? props.theme.text:props.theme.text};
}

@media (max-width: 768px) {
  top:${props=>props.click? '85%':'50%'};
  left:${props=>props.click? '90%':'50%'};

  &>:last-child{
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  top:${props=>props.click? '85%':'50%'};
  left:${props=>props.click? '85%':'50%'};
  
  &>:first-child{
    width: ${props => props.click ? '80px' : '60px'};
    height: ${props => props.click ? '80px' : '60px'};
  }

  &>:last-child{
    font-size: 0.7rem;
  }
}`


const DarkDiv = styled.div`
  position: absolute;
  top: 0;
  background-color: #000;
  bottom: 0;
  right: 50%;
  width: ${(props) => (props.click ? '50%' : '0%')};
  height: ${(props) => (props.click ? '100%' : '0%')};
  z-index: 1;
  transition: height 0.5s ease, width 1s ease 0.5s;
  }`


const Main = () => {
  const [click, setClick] = useState(false); 
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Function to enter fullscreen
  const enterFullscreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
      document.documentElement.msRequestFullscreen();
    }
  };

  // Function to exit fullscreen
  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  // Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  // Handle "Click here" button - enter fullscreen and show intro
  const handleClickHere = () => {
    setClick(true);
    enterFullscreen();
  };

  // Handle yin-yang button in intro - toggle intro and re-enter fullscreen if needed
  const handleYinYangClick = () => {
    setClick(!click);
    
    // If we're hiding the intro (click will become false), check if we need to re-enter fullscreen
    if (click && !isFullscreen) {
      // User is hiding intro and not in fullscreen, so re-enter fullscreen
      enterFullscreen();
    }
  };

  return (
    <MainContainer>
    <DarkDiv click={click}/>
      <Container>
        <PowerButton onToggle={click ? handleYinYangClick : undefined} isIntroPage={click} theme={click ? 'dark' : 'light'} />
        <LogoComponent theme={click?'dark':'light'} />
        <SocialIcons theme={click?'dark':'light'} />
      

        <Center click={click}>
          <YinYang onClick={()=> click ? handleYinYangClick() : handleClickHere()} width={click?'100%':'100%'} height={click?'100%':'100%'} fill='currentColor' />
          <span>Click here</span>
        </Center>

        {/* Using a real <a> tag for proper mailto functionality */}
        <Contact>
          <a target='_blank' rel="noreferrer" href="mailto:pratikpatil.dev.in@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>
            <motion.h2
            initial={{
              y:-200,
              transition:{type:'spring',duration:1.5,delay:0.5}
            }}
            animate={{
              y:0,
              transition:{type:'spring',duration:1.5,delay:0.5}
            }}
            whileHover={{scale:1.1}}
            whileTap={{scale:0.9}}
            >Say hi..</motion.h2>
          </a>
        </Contact>

        <FEATS to="/feats">
          <motion.h2
          initial={{
            y:-200,
    
          }}
          animate={{
            y:0,
            transition:{type:'spring',duration:1.5,delay:0.5}
          }}
            whileHover={{scale:1.1}}
            whileTap={{scale:0.9}}>
            Feats
          </motion.h2>
        </FEATS>

        <PROJECTS to="/projects" click={click}>
          <motion.h2
          initial={{
            y:-200,
            transition:{type:'spring',duration:1.5,delay:0.5}
          }}
          animate={{
            y:0,
            transition:{type:'spring',duration:1.5,delay:0.5}
          }}
            whileHover={{scale:1.1}}
            whileTap={{scale:0.9}}>
            Projects
          </motion.h2>
        </PROJECTS>
        <BottomBar>
        <ABOUT to="/about" click={click}>
          <motion.h2
          initial={{
            y:200,
            transition:{type:'spring',duration:1.5,delay:0.5}
          }}
          animate={{
            y:0,
            transition:{type:'spring',duration:1.5,delay:0.5}
          }}
            whileHover={{scale:1.1}}
            whileTap={{scale:0.9}}>
            About
          </motion.h2>
        </ABOUT>
        <SKILLS to="/skills">
          <motion.h2
          initial={{
            y:200,
            transition:{type:'spring',duration:1.5,delay:0.5}
          }}
          animate={{
            y:0,
            transition:{type:'spring',duration:1.5,delay:0.5}
          }}
            whileHover={{scale:1.1}}
            whileTap={{scale:0.9}}>
            My Skills
          </motion.h2>
        </SKILLS> 
        </BottomBar>
        
        {click?<Intro click={click}/>:null}

      </Container>
    </MainContainer>
  );
}

export default Main;